import { forwardRef } from 'react';

import Box from '@mui/material/Box';
import NoSsr from '@mui/material/NoSsr';

import { RouterLink } from 'src/routes/components';

import { useAppTheme } from 'src/hooks/use-app-theme';

import { logoClasses } from './classes';

// ----------------------------------------------------------------------

export const Logo = forwardRef(
  ({ width = 30, height = 30, disableLink = false, className, href = '/', sx, ...other }, ref) => {
    /*
     * OR using local (public folder)
    */
    // const logo = ( <Box alt="logo" component="img" src={`${CONFIG.site.basePath}logo/logo-single.svg`} width={width} height={height} /> );
    const { currentTheme } = useAppTheme();
    const logo = (<Box alt="logo" component="img" src={currentTheme.LOGO} width={width} height={height} />);

    return (
      <NoSsr
        fallback={
          <Box
            width={width}
            height={height}
            className={logoClasses.root.concat(className ? ` ${className}` : '')}
            sx={{
              flexShrink: 0,
              display: 'inline-flex',
              verticalAlign: 'middle',
              ...sx,
            }}
          />
        }
      >
        <Box
          ref={ref}
          component={RouterLink}
          href={href}
          width={width}
          height={height}
          className={logoClasses.root.concat(className ? ` ${className}` : '')}
          aria-label="logo"
          sx={{
            flexShrink: 0,
            display: 'inline-flex',
            verticalAlign: 'middle',
            ...(disableLink && { pointerEvents: 'none' }),
            ...sx,
          }}
          {...other}
        >
          {logo}
        </Box>
      </NoSsr>
    );
  }
);
